// extracted by mini-css-extract-plugin
module.exports =  {"AppButton":"AppButton-module__AppButton___GBsIP","right":"AppButton-module__right___AHNa9"};